module.exports = __webpack_public_path__ + "static/media/bn.2a3eb5a9.svg";